import type { UpdateBlockParameters } from './updateBlock'
import { updateBlock } from './updateBlock'

export const update = (
  items: UpdateBlockParameters[0],
  blockNameCurrent: UpdateBlockParameters[1],
  block: UpdateBlockParameters[2]
) => updateBlock(items, blockNameCurrent, block, 'update')
